import { render, staticRenderFns } from "./MapBlock.vue?vue&type=template&id=3932b44a&scoped=true"
import script from "./MapBlock.vue?vue&type=script&lang=js"
export * from "./MapBlock.vue?vue&type=script&lang=js"
import style0 from "./MapBlock.vue?vue&type=style&index=0&id=3932b44a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3932b44a",
  null
  
)

export default component.exports